// extracted by mini-css-extract-plugin
module.exports = {"cardImovel":"cardImovel_cardImovel__Se9Qo","image":"cardImovel_image__W5AiJ","text":"cardImovel_text__HMkQw"};